import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import Tabs from "components/lib/Shared/Tabs";
import Button from "components/lib/Shared/Button";
import SignatureDocument from "./SignatureDocument";
import { useSelector, useDispatch } from "react-redux";
import { handleFilesUpload } from "utils/filesUtils";
import { Constants } from "config/constants";
import { useToast } from "hooks/useToast";

const TransactionApprovalsSignatureTab = (props) => {
  const { toast } = useToast(500);
  const { transactionUnderReview } = useSelector(
    (state) => state.transactionSlice
  );
  const { trxId } = useParams();
  const { transactions, unsignedApprovalFileUploads, approvalDocs } =
    transactionUnderReview.items;
  const fileUploads = unsignedApprovalFileUploads;
  const { officialIndex, actionType, documents } = props;
  const initialTabs = React.useMemo(() => {
    if (!transactions.length) return [];
    const tabs = [
      {
        key: "director_approval",
        label: "Director Signature",
        type: "boardApproval",
      },
      {
        key: "shareholder_approval",
        label: "Shareholder Signature",
        type: "shareholderApproval",
      },
    ];
    const filteredTabs = tabs.filter(({ key }) => {
      if (key === "director_approval") {
        return transactions?.some(
          (transaction) =>
            transaction._id === trxId &&
            transaction.status ===
            Constants.MAINTAIN_COMPANY_SIGNATURE_STATUS.DIRECTOR_SIGNATURE
        );
      }
      if (key === "shareholder_approval") {
        return transactions?.some(
          (transaction) =>
            transaction._id === trxId &&
            transaction.status ===
            Constants.MAINTAIN_COMPANY_SIGNATURE_STATUS.SHAREHOLDER_SIGNATURE
        );
      }
      return false;
    });

    const mappedTabs = filteredTabs.map(({ key, label }) => ({
      id: key,
      label,
    }));

    return mappedTabs;
  }, [transactions, unsignedApprovalFileUploads]);

  const [tabs, setTabs] = useState(initialTabs);
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState([]);
  const [formData, setFormData] = useState({
    ownConsentResolutionForDirectorApproval: null,
    ownConsentResolutionForShareholderApproval: null,
  });

  useEffect(() => {
    setSelectedTab(tabs[selectedTabIndex]);
  }, [selectedTabIndex]);

  useEffect(() => {
    if (
      formData.ownConsentResolutionForDirectorApproval ||
      formData.ownConsentResolutionForShareholderApproval
    ) {
      setError([]);
    }
  }, [formData]);

  return (
    <div>
      {
        <Tabs
          tabs={initialTabs}
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={setSelectedTabIndex}
        />
      }
      <div className="flex flex-col gap-4">
        {selectedTab.id === "director_approval" && (
          <SignatureDocument
            signedDocumentType={"signedDirectorApprovalDocs"}
            selectedTab={selectedTab}
            fileUploads={fileUploads}
            document={
              approvalDocs.find(
                (doc) => Object.keys(doc)[0] === "directorApprovalDocs"
              ).directorApprovalDocs
            }
            documentType="directorApprovalDocs"
            actionType={actionType}
            setFormData={setFormData}
            error={error}
          />
        )}
        {selectedTab.id === "shareholder_approval" && (
          <SignatureDocument
            signedDocumentType={"signedShareholderApprovalDocs"}
            officialIndex={officialIndex}
            selectedTab={selectedTab}
            document={
              approvalDocs.find(
                (doc) => Object.keys(doc)[0] === "shareholderApprovalDocs"
              ).shareholderApprovalDocs
            }
            documentType="shareholderApprovalDocs"
            actionType={actionType}
            fileUploads={fileUploads}
            setFormData={setFormData}
            error={error}
          />
        )}
      </div>
    </div>
  );
};

export default TransactionApprovalsSignatureTab;
